import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { createActionStream } from '@core/ngrx-legacy';
import { TellentOrganizationActions } from '@core/tellent-data';
import { AddOrgPayload } from '@core/tellent-types';

@Injectable({
  providedIn: 'root',
})
export class TellentOrganizationDataFacade {
  private readonly store = inject(Store);

  public readonly addOrgSuccess$ = createActionStream(TellentOrganizationActions.addOrgSuccess);

  public addOrg(payload: AddOrgPayload) {
    this.store.dispatch(TellentOrganizationActions.addOrg({ payload }));
  }
}
